import { connect } from 'react-redux';
import { compose } from 'redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import EditActionButton from 'automation-ui-canvas/components/action-card-options/EditActionButton';
import { Flex } from 'foundations-components/components/Flex';
import { getIsEmbedded } from 'automation-ui-canvas/selectors/embedSelectors';
import { pasteActionInFlowAfterVirtualAction } from 'automation-ui-canvas/components/canvas/copyPaste/pasteActionInFlow';
import { wirePasteActionModalConsumer } from 'automation-ui-canvas/components/canvas/copyPaste/PasteActionModalWrapper';
import { wireUpdateFlow } from 'automation-ui-canvas/queries/flowQueries';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { ClipboardIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
export const PasteAfterVirtualActionButton = ({
  dispatch,
  flow,
  nodeId,
  setPastingData,
  showLoadingOverlay = () => {},
  showPasteActionModal,
  updateFlow,
  isEmbedded
}) => {
  const getCopyPaste = () => {
    return [{
      label: nodeId === SpecialActionIds.ENROLLMENT ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "automation.common.editActionDropdown.paste.afterEnrollment"
      }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "automation.common.editActionDropdown.paste.after"
      }),
      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        pasteActionInFlowAfterVirtualAction({
          baseActionId: nodeId,
          flow,
          showLoadingOverlay,
          setPastingData,
          showPasteActionModal,
          updateFlow,
          dispatch
        });
      }
    }];
  };
  if (isEmbedded) return null;
  return /*#__PURE__*/_jsx("div", {
    onClick: event => event.stopPropagation(),
    children: /*#__PURE__*/_jsx(Flex, {
      gap: "200",
      children: /*#__PURE__*/_jsx(EditActionButton, {
        IconAsset: ClipboardIcon,
        defaultTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.editActionDropdown.copyPaste"
        }),
        options: getCopyPaste()
      }, "copyPaste")
    })
  });
};
const mapStateToProps = state => ({
  isEmbedded: getIsEmbedded(state)
});
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default compose(connect(mapStateToProps, mapDispatchToProps), wireUpdateFlow, wirePasteActionModalConsumer)(PasteAfterVirtualActionButton);